import * as React from 'react';

import { cn } from '../../lib/utils';

const Dashboard = React.forwardRef<HTMLDivElement, React.ComponentProps<'div'>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      data-slot='dashboard'
      className={cn('tw:mx-auto tw:mt-6 tw:w-full tw:max-w-[var(--max-width-container)] tw:px-4', className)}
      {...props}
    />
  ),
);
Dashboard.displayName = 'Dashboard';

type SidebarSize = 'sm' | 'md' | 'lg';

// Breakpoint = page max-width (1200px in emissions) + sidebar width + gap.
// Each variant must be a complete literal class so Tailwind's scanner picks it up.
export const SIDEBAR_SHOW_AT: Record<SidebarSize, string> = {
  sm: 'tw:min-[1420px]:block', // ~160px sidebar
  md: 'tw:min-[1600px]:block', // ~250px sidebar (Insights)
  lg: 'tw:min-[2200px]:block', // ~500px sidebar
};

export const SIDEBAR_HIDE_AT: Record<SidebarSize, string> = {
  sm: 'tw:min-[1420px]:hidden', // ~160px sidebar
  md: 'tw:min-[1600px]:hidden', // ~250px sidebar (Insights)
  lg: 'tw:min-[2200px]:hidden', // ~500px sidebar
};

interface DashboardWithSidebarProps extends React.ComponentProps<'div'> {
  sidebar: React.ReactNode;
  sidebarSize?: SidebarSize;
}

const DashboardWithSidebar = React.forwardRef<HTMLDivElement, DashboardWithSidebarProps>(
  ({ className, sidebar, children, sidebarSize = 'md', ...props }, ref) => (
    <div
      ref={ref}
      data-slot='dashboard-with-sidebar'
      className={cn(
        'tw:relative tw:mx-auto tw:mt-6 tw:w-full tw:max-w-[var(--max-width-container)] tw:px-4',
        className,
      )}
      {...props}
    >
      <div className={cn('tw:hidden tw:absolute tw:top-0 tw:right-full', SIDEBAR_SHOW_AT[sidebarSize])}>
        {sidebar}
      </div>
      <div className='tw:min-w-0'>{children}</div>
    </div>
  ),
);
DashboardWithSidebar.displayName = 'DashboardWithSidebar';

export { Dashboard, DashboardWithSidebar };
